import { B as BxfIcon$1, d as defineCustomElement$1 } from './p-6c17fe8d.js';

const BxfIcon = BxfIcon$1;
const defineCustomElement = defineCustomElement$1;

export { BxfIcon, defineCustomElement };
